export const shouldTransformCasing = (text: string) =>
  text === text.toUpperCase();

export const enforceCasing = (text: string) =>
  shouldTransformCasing(text) ? text.toLowerCase() : text;
